interface Metric {
  name: string;
  value: number;
  timestamp: number;
  labels?: Record<string, string>;
}

class MetricsCollector {
  private static instance: MetricsCollector;
  private metrics: Metric[] = [];
  private readonly maxMetrics = 1000;

  private constructor() {}

  static getInstance(): MetricsCollector {
    if (!MetricsCollector.instance) {
      MetricsCollector.instance = new MetricsCollector();
    }
    return MetricsCollector.instance;
  }

  record(name: string, value: number, labels?: Record<string, string>) {
    this.metrics.push({
      name,
      value,
      timestamp: Date.now(),
      labels
    });

    // Limitar o número de métricas armazenadas
    if (this.metrics.length > this.maxMetrics) {
      this.metrics = this.metrics.slice(-this.maxMetrics);
    }
  }

  getMetrics(name?: string): Metric[] {
    if (name) {
      return this.metrics.filter(m => m.name === name);
    }
    return [...this.metrics];
  }

  getLatestMetric(name: string): Metric | undefined {
    return this.metrics
      .filter(m => m.name === name)
      .sort((a, b) => b.timestamp - a.timestamp)[0];
  }

  clearMetrics() {
    this.metrics = [];
  }

  // Métricas específicas
  recordApiLatency(endpoint: string, latencyMs: number) {
    this.record('api_latency', latencyMs, { endpoint });
  }

  recordCacheHit(key: string) {
    this.record('cache_hits', 1, { key });
  }

  recordCacheMiss(key: string) {
    this.record('cache_misses', 1, { key });
  }

  recordError(type: string) {
    this.record('errors', 1, { type });
  }

  recordQueueSize(size: number) {
    this.record('queue_size', size);
  }

  recordProcessingTime(operation: string, timeMs: number) {
    this.record('processing_time', timeMs, { operation });
  }
}

export const metrics = MetricsCollector.getInstance();